module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report"
  }, [_c('PageTitle', {
    attrs: {
      "pagetitle": "转化效果分析过程",
      "tip": "对影响账户转化数据的相关指标进行深入分析，找出影响转化效果的问题指标，针对性给出优化建议。",
      "showTime": false
    }
  }), _c('div', {
    staticClass: "zone opt-zone"
  }, [_c('div', [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-signal",
      "title": "展现量&点击率分析"
    }
  }), _vm._m(0), (_vm.currentTopChart == 'quad') ? _c('div', [_c('QuadChart', {
    attrs: {
      "listSeries": _vm.getTopQuadSeries,
      "avgSeries": _vm.topQuadAvgSeries,
      "loading": _vm.topQuadLoading,
      "axisNames": _vm.topQuadNames
    },
    on: {
      "quadPosition": _vm.setTopQuadPosition
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.topQuadInfo),
      expression: "topQuadInfo"
    }],
    staticClass: "chart-tip"
  }, [_vm._v(_vm._s(_vm.topQuadInfo))])], 1) : _vm._e()], 1)]), _c('div', {
    staticClass: "zone opt-zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-signal",
      "title": "账户计划预算分析"
    }
  }), _c('div', [_c('div', {
    staticClass: "bar-picker-wrapper"
  }, [_c('v-date-picker', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.baseDate),
      expression: "baseDate"
    }],
    attrs: {
      "max-date": _vm.yesterday,
      "min-date": _vm.yearAgo
    },
    domProps: {
      "value": (_vm.baseDate)
    },
    on: {
      "input": function($event) {
        _vm.baseDate = $event
      }
    }
  })], 1)]), (_vm.currentMidChart == 'bar') ? _c('div', [_c('table', {
    staticClass: "mid-charts"
  }, [_c('tr', [_c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('BarChart', {
    attrs: {
      "hirizonal": _vm.hirizonalBar,
      "series": _vm.getLeftBarSeries,
      "color": _vm.leftBarColor,
      "loading": _vm.leftBarLoading
    }
  })], 1), _c('td', {
    attrs: {
      "width": "50%"
    }
  }, [_c('BarChart', {
    attrs: {
      "hirizonal": _vm.hirizonalBar,
      "series": _vm.getRightBarSeries,
      "color": _vm.rightBarColor,
      "loading": _vm.rightBarLoading
    }
  })], 1)])]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.leftBarSeries.length > 0 || _vm.rightBarSeries.length > 0),
      expression: "leftBarSeries.length>0 || rightBarSeries.length>0"
    }],
    staticClass: "chart-tip",
    domProps: {
      "innerHTML": _vm._s(_vm.midBarContent)
    }
  })]) : _vm._e()], 1), _c('div', {
    staticClass: "zone opt-zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-signal",
      "title": "CPC&转化率分析"
    }
  }), _vm._m(1), _c('QuadChart', {
    attrs: {
      "listSeries": _vm.getBottomQuadSeries,
      "avgSeries": _vm.bottomQuadAvgSeries,
      "loading": _vm.bottomQuadLoading,
      "axisNames": _vm.bottomQuadNames
    },
    on: {
      "quadPosition": _vm.setBottomQuadPosition
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bottomQuadInfo),
      expression: "bottomQuadInfo"
    }],
    staticClass: "chart-tip"
  }, [_vm._v(_vm._s(_vm.bottomQuadInfo))])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timespan-wrapper"
  }, [_c('span', {
    staticClass: "timespan"
  }, [_vm._v("最近7天")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timespan-wrapper"
  }, [_c('span', {
    staticClass: "timespan"
  }, [_vm._v("最近7天")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-02fb9240", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-02fb9240!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/viewprocess.vue
// module id = 705
// module chunks = 0